export const getTexts = (state) => state.texts || {};
